export default "__VITE_ASSET__BwqK2len__"